import { getInnerElement, checkElementsNumber } from './tools'

export const track = (element, state) => {
  const vehicleCountEl = getInnerElement(element, 'vehicleCount')
  if (vehicleCountEl) {
    vehicleCountEl.textContent = state.get('vehicleCount')
  }
}
